import { http } from '../../../plugins/axios'

const actions = {
  getAllIncidents ({commit}, payload) {
    let url = `inspection-issues`
    let options = {
      emulateJSON: false
    }
    let params = {
      //COMENTADO POR CAMBIO DEL ENDPOINT
      // 'vin': payload.event.vin ? payload.event.vin : undefined,
      // 'plates': payload.event.plate ? payload.event.plate : undefined,
      // 'unit_number': payload.event.unit_number ? payload.event.unit_number : undefined,
      // 'date_start': payload.event.date_start ? payload.event.date_start : undefined,
      // 'date_end': payload.event.date_end ? payload.event.date_end : undefined,
      'user_id': payload.event.user_id ? payload.event.user_id : undefined,
      'site_id': payload.event.site_id ? payload.event.site_id : undefined,
      // 'level_damage': payload.event.levelDamage ? payload.event.levelDamage : undefined,

      'unit_id': payload.event.unit_id ? payload.event.unit_id : undefined,
      'year': payload.event.year ? payload.event.year : undefined,
      'page': payload.event.page ? payload.event.page : undefined,
      'perPage': payload.event.perPage ? payload.event.perPage : undefined,
      'ord': payload.event.ord ? payload.event.ord : 'desc',
      'sortKey': payload.event.sortKey ? payload.event.sortKey : 'id'
    }
    http.get(url, { params }, options).then(
      response => {
        commit('onGetAll', { event: payload.event, response })
      },
      error => {
        commit('onError', { event: payload.event, error })
      }
    )
  },
  getIncidentById ({commit}, payload) {
    let url = `inspection-issues/${payload.event.id}`
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options).then(
      response => {
        commit('onGetById', { event: payload.event, response })
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      }
    )
  },
  getGalleryReport ({commit}, payload) {
    let options = {
      emulateJSON: false
    }
    let type = payload.event.type
    let perPage = payload.event.perPage
    let page = payload.event.page
    let unitId = payload.event.unit_id
    let arrayT = ''
    payload.event.id.forEach((e, index) => 
    arrayT = arrayT + (`inspection_issues_id[${index}]=${e}&`)
    )
    let url = `inspection-issues-gallery?${arrayT}type=${type}&perPage=${perPage}&page=${page}`
        if (unitId) {
        url += `&unit_id=${unitId}`
    }
    http.get(url, type === 'download' ? { responseType: 'blob' } : {}, options)
    .then(response => {
        commit('onGetGalleryReport', { event: payload.event, response })
      },
      error => {
        commit('onError', { event: payload.event, error })
      }
    )
  },
  getGallery ({ commit }, payload) {
    let options = {
      emulateJSON: false
    }
    let params = {
      'perPage': payload.event.perPage,
      'page': payload.event.page
    }
    let url = `inspection-issues-gallery-by-id/${payload.event.inspectionsById}`
    http.get(url, { params }, options)
    .then(response => {
        commit('onGetGallery', { event: payload.event, response })
      },
      error => {
        commit('onError', { event: payload.event, error })
      }
    )
  }
}

export default actions